import { useNotifier } from '@provider/notifier';
import { breakpoints } from '@ui/css';
import { Button } from '@ui/kit';
import { AddTeamIcon } from '@ui/kit/icons';
import { HideFor, ShowFor } from '@utils/react';
import { header, heading } from '../../shared.header.style.js';
import { createTeamButton, contentWrapperCls, tableHeading } from './_page.style.js';
import { makeTeamModalConfig } from './modal.create-team.js';
import { MyTeams } from './root.js';
import { jsxs, jsx } from 'react/jsx-runtime';

function MyTeamsPane() {
  const notifier = useNotifier();
  const handleCreateTeam = () => {
    notifier.modal(makeTeamModalConfig({}));
  };
  return /*#__PURE__*/jsxs("div", {
    children: [/*#__PURE__*/jsxs("header", {
      className: header,
      children: [/*#__PURE__*/jsx("h1", {
        className: heading,
        children: "Mine hold"
      }), /*#__PURE__*/jsx(HideFor, {
        breakpoint: breakpoints.mobile,
        className: createTeamButton,
        children: /*#__PURE__*/jsx(Button, {
          theme: "primary",
          icon: /*#__PURE__*/jsx(AddTeamIcon, {}),
          onClick: handleCreateTeam,
          children: "Opret hold"
        })
      })]
    }), /*#__PURE__*/jsxs("div", {
      className: contentWrapperCls,
      children: [/*#__PURE__*/jsx(ShowFor, {
        breakpoint: breakpoints.mobile,
        className: tableHeading,
        children: /*#__PURE__*/jsx("div", {
          "aria-hidden": true,
          children: "Modtag notifikationer"
        })
      }), /*#__PURE__*/jsx(MyTeams, {})]
    })]
  });
}

export { MyTeamsPane };
//# sourceMappingURL=_page.js.map
